export const KEY_ENTER = "Enter";
export const KEY_ESCAPE = "Escape";
export const KEY_UP = "ArrowUp";
export const KEY_DOWN = "ArrowDown";
export const KEY_SPACE = " ";
